import { Box, Divider, Loader, SectionHelper } from '@wix/design-system';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { SwitchProductModule } from '../../switch-product.module';
import { FeaturesNamespace } from './FeaturesNamespace';
export const PlanFeaturesModalContent = () => {
  var _currentProductData$c, _featuresGridData$nam, _currentProductData$c2;
  const {
    Trans
  } = SwitchProductModule.internals.useTranslations();
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const {
    data: currentProductData,
    isLoading: isCurrentProductLoading
  } = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const productId = (currentProductData == null || (_currentProductData$c = currentProductData.currentProduct) == null ? void 0 : _currentProductData$c.productId) ?? '';
  const shouldShowSectionHelper = !(currentProductData != null && currentProductData.isCurrentProductFamilyInOffering) && !(currentProductData != null && currentProductData.isCurrentProductInOffering);
  const {
    data: featuresGridData,
    isLoading: isFeaturesGridLoading
  } = PremiumPurchasePlatformModule.SDK.ApiClient.hooks.useGetFeaturesGrid({
    productIds: [productId],
    ...p3Context
  }, !isCurrentProductLoading && !!productId);
  const isLoading = isFeaturesGridLoading || isCurrentProductLoading;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Box, {
      align: "center",
      height: "100%"
    }, /*#__PURE__*/React.createElement(Loader, null));
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, featuresGridData == null || (_featuresGridData$nam = featuresGridData.namespaces) == null ? void 0 : _featuresGridData$nam.map((ns, index) => {
    var _featuresGridData$nam2;
    const lastIndex = ((featuresGridData == null || (_featuresGridData$nam2 = featuresGridData.namespaces) == null ? void 0 : _featuresGridData$nam2.length) ?? 0) - 1;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: ns.id
    }, /*#__PURE__*/React.createElement(FeaturesNamespace, {
      key: ns.id,
      namespace: ns
    }), index < lastIndex && /*#__PURE__*/React.createElement(Divider, {
      key: `divider-${index}`
    }));
  })), shouldShowSectionHelper && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SectionHelper, {
    skin: "standard"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "change_plan.current_plan_modal.explanation_advanced",
    values: {
      planName: currentProductData == null || (_currentProductData$c2 = currentProductData.currentProduct) == null ? void 0 : _currentProductData$c2.productName
    },
    components: [/*#__PURE__*/React.createElement("strong", null)]
  }))));
};
//# sourceMappingURL=PlanFeaturesModalContent.js.map